import { useTranslation } from '@bcba/react-hooks';
import { PageHeader } from '@bcba/frontend-utils';
import UserProfile from '../components/UserProfile/UserProfile';
import { Box, Divider, Flex } from '@agrotoken-tech/ui';

const UserProfilePage = () => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap={10}>
      <PageHeader title={t('explorer.navigation.menu.profile')} />
      <Box>
        <Divider />
      </Box>
      <UserProfile />
    </Flex>
  );
};

export default UserProfilePage;
